<template>
    <l-marker :lat-lng="[balise.lastLatitude, balise.lastLongitude]">
        <l-icon class-name="someExtraClass" :icon-size="[96, 48]" :icon-anchor="[48, 24]">
            <VehicleIcon :icon="balise.icon" :parking="this.balise.parkingLat !== null ? true : false"
                :warning="this.warning ? true : false" :warningColor="this.warningColor" />
            <div class="text-center bg-info bg-opacity-50 rounded" style="width: 96px">{{ balise.name }}</div>
        </l-icon>
    </l-marker>
</template>

<script>
import { LMarker, LIcon } from "@vue-leaflet/vue-leaflet";
import VehicleIcon from '@/components/display/VehicleIcon.vue'

export default {
    props: {
        balise: {
            required: true
        },
        warning: {
            default: false
        },
        warningColor: {
            default: "red"
        }
    },
    components: {
        LMarker,
        LIcon,
        VehicleIcon
    },
}
</script>